import { useState, useEffect } from "react";
import { getCart } from "../services/cartService";
import { S_LANG, webStorage } from "../utils/webStorage";
const useCartData = () => {
  const [cartSpuIds, setCartSpuIds] = useState([]);
  const [cartQtyList, setCartQtyList] = useState([]);
  const [totalAmount, setTotalAmount] = useState([]);
  const init = async () => {
    const lang = webStorage.get(S_LANG);
    const res = await getCart(lang);
    let { skuList, afterDiscountTotalPrice } = res.obj;
    skuList = skuList ? skuList : [];
    const cartSpuIds = [];
    const cartQtyList = [
      {
        qty: 1,
        skuId: 1566
      },
      {
        qty: 1,
        skuId: 1600
      },
      {
        qty: 1,
        skuId: 1618
      },
      {
        qty: 1,
        skuId: 1602
      },
      {
        qty: 1,
        skuId: 1623
      },
      {
        qty: 1,
        skuId: 1640
      }
    ];
    // const cartQtyList = skuList.map(x => ({
    //   skuId: x.skuId,
    //   qty: x.skuCount
    // }));
    for (let skuItem of skuList) {
      if (!cartSpuIds.includes(skuItem.spuId)) {
        cartSpuIds.push(skuItem.spuId);
      }
    }
    setCartSpuIds(cartSpuIds);
    setCartQtyList(cartQtyList);
    setTotalAmount(afterDiscountTotalPrice);
  };
  return {
    cartSpuIds,
    cartQtyList,
    totalAmount
  };
};
export default useCartData;
